module.exports = __webpack_public_path__ + "static/img/pspimage.4e71089.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/pspimage.png
// module id = 0RMb
// module chunks = 53